import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyCustomersState } from '../reducers/index';

export const getDragonflyCustomers = createSelector(
  getDragonflyCustomersState,
  (state) => state?.allCustomers,
);

export const getMainPanelExpanded = createSelector(
  getDragonflyCustomers,
  (state) => state?.mainPanelExpanded,
);

export const getPersonalPanelExpanded = createSelector(
  getDragonflyCustomers,
  (state) => state?.personalPanelExpanded,
);

export const getOtherPanelExpanded = createSelector(
  getDragonflyCustomers,
  (state) => state?.otherPanelExpanded,
);

export const getRegistrationDateFrom = createSelector(getDragonflyCustomers, (state) =>
  state?.registrationDateFrom?.trim() ? state.registrationDateFrom : 0,
);

export const getRegistrationDateUntil = createSelector(getDragonflyCustomers, (state) =>
  state?.registrationDateUntil?.trim() ? state.registrationDateUntil : 0,
);

export const getRegistrationDateFromZ = createSelector(
  getRegistrationDateFrom,
  (registrationDateFrom) => new Date(registrationDateFrom),
);

export const getRegistrationDateUntilZ = createSelector(
  getRegistrationDateUntil,
  (registrationDateUntil) => new Date(registrationDateUntil),
);

export const getRegistrationDateFromValidation = createSelector(
  getRegistrationDateFromZ,
  (registrationDateFromZ) =>
    registrationDateFromZ?.toISOString() !== new Date(0).toISOString() ? registrationDateFromZ : '',
);

export const getRegistrationDateUntilValidation = createSelector(
  getRegistrationDateUntilZ,
  (registrationDateUntilZ) =>
    registrationDateUntilZ?.toISOString() !== new Date(0).toISOString()
      ? registrationDateUntilZ
      : '',
);

export const getRegistrationDateLTStartDate = createSelector(
  getRegistrationDateFromZ,
  getRegistrationDateUntilZ,
  (registrationDateFromZ, registrationDateUntilZ) =>
    registrationDateFromZ > registrationDateUntilZ &&
    registrationDateFromZ?.toISOString() !== new Date(0).toISOString() &&
    registrationDateUntilZ?.toISOString() !== new Date(0).toISOString(),
);

export const getFirstName = createSelector(getDragonflyCustomers, (state) => state?.firstName);

export const getEmail = createSelector(getDragonflyCustomers, (state) => state?.email);

export const getLastName = createSelector(getDragonflyCustomers, (state) => state?.lastName);

export const getMobile = createSelector(getDragonflyCustomers, (state) => state?.mobile);

export const getMemberTagOptions = createSelector(
  getDragonflyCustomers,
  (state) => state?.memberTagOptions,
);

export const getMemberTag = createSelector(getDragonflyCustomers, (state) => state?.memberTag);

export const getQivosID = createSelector(getDragonflyCustomers, (state) => state?.qivosID);

export const getAttributeTypeOptions = createSelector(
  getDragonflyCustomers,
  (state) => state?.attributeTypeOptions,
);

export const getAttributeType = createSelector(
  getDragonflyCustomers,
  (state) => state?.attributeType,
);

export const getAttributeNameOptions = createSelector(
  getDragonflyCustomers,
  (state) => state?.attributeNameOptions,
);

export const getAttributeName = createSelector(
  getDragonflyCustomers,
  (state) => state?.attributeName,
);

export const getAttributeNameStringOrInteger = createSelector(
  getAttributeType,
  getAttributeName,
  (attributeType, attributeName) =>
    attributeName && (attributeType === 'INTEGER' || attributeType === 'STRING'),
);

export const getAttributeNameInteger = createSelector(
  getAttributeType,
  getAttributeName,
  (attributeType, attributeName) => attributeName && attributeType === 'INTEGER',
);

export const getAttributeNameBoolean = createSelector(
  getAttributeType,
  getAttributeName,
  (attributeType, attributeName) => attributeName && attributeType === 'BOOLEAN',
);

export const getAttributeNameDate = createSelector(
  getAttributeType,
  getAttributeName,
  (attributeType, attributeName) => attributeName && attributeType === 'DATE',
);

export const getAttributeValue = createSelector(
  getDragonflyCustomers,
  (state) => state?.attributeValue,
);

export const getAttributeBoolValue = createSelector(
  getDragonflyCustomers,
  (state) => state?.attributeBoolValue,
);

export const getAttributeDateFrom = createSelector(getDragonflyCustomers, (state) =>
  state?.attributeDateFrom?.trim() ? state.attributeDateFrom : 0,
);

export const getAttributeDateUntil = createSelector(getDragonflyCustomers, (state) =>
  state?.attributeDateUntil?.trim() ? state.attributeDateUntil : 0,
);

export const getAttributeDateFromZ = createSelector(
  getAttributeDateFrom,
  (attributeDateFrom) => new Date(attributeDateFrom),
);

export const getAttributeDateUntilZ = createSelector(
  getAttributeDateUntil,
  (attributeDateUntil) => new Date(attributeDateUntil),
);

export const getAttributeDateFromValidation = createSelector(
  getAttributeDateFromZ,
  (attributeDateFromZ) =>
    attributeDateFromZ?.toISOString() !== new Date(0).toISOString() ? attributeDateFromZ : '',
);

export const getAttributeDateUntilValidation = createSelector(
  getAttributeDateUntilZ,
  (attributeDateUntilZ) =>
    attributeDateUntilZ?.toISOString() !== new Date(0).toISOString() ? attributeDateUntilZ : '',
);

export const getAttributeDateLTStartDate = createSelector(
  getAttributeDateFromZ,
  getAttributeDateUntilZ,
  (attributeDateFromZ, attributeDateUntilZ) =>
    attributeDateFromZ > attributeDateUntilZ &&
    attributeDateFromZ?.toISOString() !== new Date(0).toISOString() &&
    attributeDateUntilZ?.toISOString() !== new Date(0).toISOString(),
);

export const getIncludeInactive = createSelector(
  getDragonflyCustomers,
  (state) => state?.includeInactive,
);

export const getDisableSearch = createSelector(
  getRegistrationDateLTStartDate,
  getAttributeDateLTStartDate,
  (registrationDateLTStartDate, attributeDateLTStartDate) =>
    registrationDateLTStartDate || attributeDateLTStartDate,
);

export const getEditRole = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('loyaltymember.action.edit') ? true : false,
);
